import axios from "./index";

class TarifasApi {
  static fetchTarifas = () => {
    return axios.get(`/procesos/tarifas/`);
  };
  static obtenerLimitesTarifa = (tarifaId) => {
    return axios.get(`/procesos/tarifas/${tarifaId}/limitesTarifa/`);
  };

  static fetchTarifaById = (tarifaId) => {
    return axios.get(`/procesos/tarifas/${tarifaId}/`);
  };

  static createTarifa = (data) => {
    return axios.post(`/procesos/tarifas/crear/`, data);
  };

  static updateTarifa = (id, data) => {
    return axios.put(`/procesos/tarifas/${id}/actualizar/`, data);
  };

  static deleteTarifa = (id) => {
    return axios.delete(`/procesos/tarifas/${id}/eliminar/`);
  };
}
export default TarifasApi;
